<template>
  <ul class="left-menu">
    <li>
      <a
        href="#"
        class="js-sidebar-open"
        :class="{ active : openMenu }"
        @click="setOpen"
      >
        <app-icon
          name="olympus-menu-icon"
          color="dark-gray"
          size="normal"
        />
      </a>
    </li>

    <li>
      <router-link to="/list">
        <app-icon
          name="olymp-newsfeed-icon"
          color="dark-gray"
          size="medium"
          otherclass="left-menu-icon"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/contacts">
        <app-icon-multiple
          name="nico-contact-icon"
          tooltip="Contacts"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>

    <li>
      <router-link to="/birthdays">
        <app-icon-multiple
          name="olymp-cupcake-icon"
          tooltip="Birthdays"
          color="dark-gray"
          size="medium"
        />
      </router-link>
    </li>
  </ul>
</template>

<script>
// eslint-disable-next-line
// import Ps from 'perfect-scrollbar';
// eslint-disable-next-line
// import '../../../css/perfect-scrollbar.css';
import AppIcon from '../AppIcon'
import AppIconMultiple from "../AppIconMultiple";

export default {
  name: 'SidebarMental',
  components: {AppIcon, AppIconMultiple},
  props: {
    // openMenuVar: {
    //   type: Boolean,
    //   default: false
    // }
  },
  // computed: {
  //   openMenu() {
  //     return this.openMenuVar;
  //   },
  // },
  data () {
    return {
      openMenu: false,
    }
  },
  watch: {
    // openMenuVar() {
    //   // this.openMenu = this.openMenuVar;
    //   console.log(this.openMenuVar);
    // },
  },
  methods: {
    getLink (item) {
      return `/${this.ppa}/${item}`
    },
    getLinkArticle() {
      return ['personal', 'mental'].includes(this.ppa)
    },
    setOpen() {
      this.openMenu = !this.openMenu
      this.$emit('openmenu', true);

    }
  },
}
</script>
